"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceEstimateBulkRequestToJSON = exports.AudienceEstimateBulkRequestFromJSONTyped = exports.AudienceEstimateBulkRequestFromJSON = exports.instanceOfAudienceEstimateBulkRequest = void 0;
var AudienceEstimateRequest_1 = require("./AudienceEstimateRequest");
/**
 * Check if a given object implements the AudienceEstimateBulkRequest interface.
 */
function instanceOfAudienceEstimateBulkRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "requests" in value;
    return isInstance;
}
exports.instanceOfAudienceEstimateBulkRequest = instanceOfAudienceEstimateBulkRequest;
function AudienceEstimateBulkRequestFromJSON(json) {
    return AudienceEstimateBulkRequestFromJSONTyped(json, false);
}
exports.AudienceEstimateBulkRequestFromJSON = AudienceEstimateBulkRequestFromJSON;
function AudienceEstimateBulkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'requests': (json['requests'].map(AudienceEstimateRequest_1.AudienceEstimateRequestFromJSON)),
    };
}
exports.AudienceEstimateBulkRequestFromJSONTyped = AudienceEstimateBulkRequestFromJSONTyped;
function AudienceEstimateBulkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'requests': (value.requests.map(AudienceEstimateRequest_1.AudienceEstimateRequestToJSON)),
    };
}
exports.AudienceEstimateBulkRequestToJSON = AudienceEstimateBulkRequestToJSON;
